<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>VIP学生</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form"
        @submit.native.prevent="getList();">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <SelectAbroad year-mode="vipStu" v-on:selabroad="function (str) { query.abroadTime = str; selList(); }"></SelectAbroad>
        <el-form-item label="学校" label-width="80px" style="margin-left:-15px;">
          <el-select v-model="query.schid" filterable clearable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in schoollist" :label="item.label" :value="item.value" :key="item.value"
              placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历">
          <el-select v-model="query.edu" filterable clearable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"
              placeholder="请选择"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="住址">
          <el-cascader :options="areaList" filterable clearable change-on-select
            :props="{ checkStrictly: true, value: 'label' }" @change="areaChange"></el-cascader>
        </el-form-item>

        <el-form-item label="来源">
          <el-cascader :options="sourselist" v-model="selectedOrigion" filterable clearable change-on-select
            :props="{ value: 'id', label: 'name', checkStrictly: true }" @change="stateClick"></el-cascader>
        </el-form-item>


        <template>
          <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;">
            <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择顾问" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="文案" label-width="80px" style="margin-left:-15px;">
            <DeptRoleTeacherSelect v-model="query.documentID" dept="留学" placeholder="请选择文案" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="营销" label-width="80px" style="margin-left:-15px;">
            <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择营销" @change="schoolClick()" />
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="性别">
            <el-select v-model="query.sex" placeholder="全部" clearable filterable @change="schoolClick()">
              <el-option label="男" :value="true"></el-option>
              <el-option label="女" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日语状况" label-width="80px">
            <el-select v-model="query.japanese" filterable clearable @change="schoolClick()">
              <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"
                placeholder="请选择等级"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄" label-width="80px">
            <el-select v-model="query.age" filterable clearable @change="schoolClick()">
              <el-option v-for="item in agelist" :label="item.name" :value="item.id" :key="item.id"
                placeholder="请选择"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赴日目的" label-width="80px">
            <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
              <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="年龄阶段" label-width="80px">
            <el-select v-model="query.ageRange" clearable placeholder="请选择" @change="selList()">
              <el-option v-for="item in ageRangeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- 新增 -->
        </template>
        <el-form-item label="缴费时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker v-model="query.daterange" clearable @change="selList()" value-format="yyyy-MM-dd"
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="录入时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker v-model="query.inputDate" clearable @change="selList()" value-format="yyyy-MM-dd"
            type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="exportClick();">导出</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>VIP学生列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width:100%;">
          <el-table-column prop="paymentDate" label="缴费时间" width="110"></el-table-column>
          <el-table-column prop="inputTime" label="添加时间" width="110"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="age" label="年龄"></el-table-column>
          <!-- <el-table-column prop="origin" label="来源"></el-table-column> -->
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span :title="scope.row.origin">{{ scope.row.origin }}</span>
              <span :title="scope.row.recName">{{ scope.row.recName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="abroadDate" label="留学时间"></el-table-column>
          <el-table-column prop="applySchool" label="申请学校"></el-table-column>
          <el-table-column prop="zzAreaShow" label="住址"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="adviserName" label="顾问"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column prop="documentName" label="文案老师"></el-table-column>
          <el-table-column prop="isAbove" label="是否前端显示">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isAbove == true">是</el-tag>
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.sex == true">男</el-tag>
              <el-tag type="warning" v-else>女</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="japanese" label="日语"></el-table-column> -->
          <!-- 留学=primary 日语=success 鸣野=warning；统一命名与颜色 -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-student="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyStu(scope.row) || isNoAdviserStu(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top" v-if="isMarketingOnlyStu(scope.row)">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1"
                    @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditStu(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>

                <el-tooltip content="评估表" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-document"
                    @click="tabClick(scope.row.id)"></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1"
                    @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 其他部门跟进详情弹窗（统一组件） -->
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />

    <!-- 操作对话框 -->
    <el-dialog :title="form.id > 0 ? '编辑学生信息' : '添加学生信息'" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="添加时间" prop="inputTime" :rules="[{ required: true, message: '请填写日期' }]">
              <el-date-picker v-model="form.inputTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="缴费时间" prop="paymentDate" :rules="[{ required: true, message: '请填写日期' }]">
              <el-date-picker v-model="form.paymentDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                placeholder="选择时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 留学时间 -->
        <el-row :gutter="20">
          <el-col :span="10">
            <!-- <el-form-item label="留学时间" prop="inputTime" :rules="[{required:true,message:'请填写日期'}]">
              <el-date-picker
                v-model="form.abroadDate"
                value-format="yyyy-MM"
                format="yyyy-MM"
                type="date"
                placeholder="选择时间"
              ></el-date-picker>
              <SelectAbroad year-mode="vipStu" v-on:selabroad="function(str){query.abroadTime=str;selList();}"></SelectAbroad>
            </el-form-item> -->
            <SelectAbroad year-mode="vipStu" ref="selectAbroad" v-on:selabroad="function (str) { form.abroadDate = str; selList(); }">
            </SelectAbroad>
          </el-col>


          <el-col :span="10">
            <!-- 留学学校 -->

            <el-form-item label="留学学校" prop="realName" :rules="[
              { required: true, message: '请选择留学学校' }
            ]">
              <!-- <el-input v-model="form.applySchool" :placeholder="form.applySchool"></el-input> -->
              <el-select v-model="form.applySchool" :filterable="true">
                <el-option v-for="item in schoollist" :label="item.label" :value="item.label"
                  :key="item.value"></el-option>
              </el-select>

              <!-- <el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="请输入内容"
                @select="handleSelect"></el-autocomplete> -->
            </el-form-item>
          </el-col>

        </el-row>





        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="姓名" prop="realName" :rules="[
              { required: true, message: '请输入姓名' }
            ]">
              <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="性别" prop="sex" :rules="[
              { required: true, message: '请输选择性别' }
            ]">
              <el-radio-group v-model="form.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="年龄" prop="age">
              <el-input v-model.number="form.age" type="number" placeholder="请输入年龄"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学生/家长" prop="studentType">
              <el-select v-model="form.studentType" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id"
                  :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="来源" prop="origin" :rules="[{ required: true, message: '请选择来源' }]">
              <el-select v-model="form.origin" placeholder="请选择来源" filterable @change="changeReouce">
                <el-option v-for="item in sourselist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="labelorgin" prop="recName" v-if="ischildren">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in tiktoklist" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐人" prop="recName" v-if="form.origin == '留学组推荐' || form.origin == '日语组推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in adviserList" :label="item.realName" :value="item.realName"
              :key="item.userID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合作方推荐" prop="recName" v-if="form.origin == '合作方推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable>
            <el-option v-for="item in partlist" :label="item.title" :value="item.title" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信" prop="wechat">
          <el-input v-model="form.wechat" placeholder="请输入微信号"></el-input>
        </el-form-item>

        <el-form-item label="QQ" prop="qq">
          <el-input v-model="form.qq" placeholder="请输入QQ号"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile">
          <el-input v-model.number="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="现住地址">
          <el-cascader :options="areaList" :props="{ label: 'label', value: 'label' }" v-model="selectedOptions"
            style="width:100%;" clearable></el-cascader>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="学历" prop="eduBack" :rules="[{ required: true, message: '请选择学历' }]">
              <el-select v-model="form.eduBack" placeholder="请选择学历" filterable>
                <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="日语" prop="japanese" :rules="[{ required: true, message: '请选择日语等级' }]">
              <el-select v-model="form.japanese" placeholder="请选择日语等级" filterable>
                <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="英语" prop="english">
              <!-- <el-select v-model="form.english" placeholder="请选择英语等级" filterable>
                <el-option v-for="item in enlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select> -->
              <el-input v-model="form.english" placeholder="请输入英语等级"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="是否前端显示">
              <el-switch v-model="form.isAbove"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <div>
          <el-divider content-position="left" style="padding:10px 0px;">修改顾问/文案老师</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="顾问老师" prop="adviserID" :rules="[{ required: true, message: '请选择' }]">
                <DeptRoleTeacherSelect v-model="form.adviserID" dept="留学" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="文案老师" prop="documentID">
                <el-select v-model="form.documentID" placeholder="请选择" filterable clearable>
                  <el-option v-for="item in documentList" :label="item.realName" :value="item.userID"
                    :key="item.userID"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 操作对话框 -->
    <el-dialog title="评估表信息" :visible.sync="evalDialogVisible">
      <el-form :model="eval" label-width="100px" :status-icon="true">
        <el-form-item label="完善地址" prop="link" :rules="[
          { required: true, message: '请输入姓名' }
        ]">
          <el-input v-model="eval.link"></el-input>
        </el-form-item>

        <el-form-item>
          <a :href="eval.link" target="_blank">
            <el-button type="info">打开链接</el-button>
          </a>

          <router-link :to="'/assess?id=' + eval.stuid" :params="{ id: eval.stuid }" style="margin-left:20px;">
            <el-button type="primary">内部完善资料</el-button>
          </router-link>
        </el-form-item>
        <!-- <hr> -->
        <el-form-item label="评估表" v-if="eval.isDown">
          <a target="_blank" :href="domain + eval.downLink">
            <el-button type="success">点击生成word</el-button>
          </a>
        </el-form-item>
        <el-alert title="完善评估表资料后即可下载！" type="warning" v-else></el-alert>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evalDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 操作对话框 -->
    <el-dialog :title="'申请案例'" :visible.sync="dialogVisiblefeel" @opened="dialogOpended()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">


        <el-form-item label="申请感受" prop="feel">
          <el-input v-model="form.feel" placeholder="请输入申请感受"></el-input>
        </el-form-item>
        <el-form-item label="合格通知书">
          <div id="uploadBtn1" class="uploader uploader-warning"></div>
          <div style="padding: 0px 10px">

            <div class="uploader-text">
              <a v-if="form.book" :href="domain + form.book" target="_blank"
                style="color: #409eff; text-decoration: none;">
                {{ form.book }}
              </a>
            </div>


          </div>
        </el-form-item>
        <el-form-item label="通知书图片" :rules="[{ required: false, message: '不能为空' }]">
          <div id="uploadBtnConfig" class="uploader uploader-warning"></div>
          <img id="relativeName" :src="domain + form.bookPhoto"
            style="height: 40px; position: relative; left: 10px; top: 20px" v-if="form.bookPhoto" />
          <span class="imgtext" title type="info" style="position: relative; left: 0px; top: 1px"></span>
        </el-form-item>
        <el-form-item label="聊天截图" prop="pictures">
          <div id="uploadBtn" class="uploader uploader-warning"></div>

          <el-row :gutter="24">
            <el-col :span="12" v-for="(item, index) in imgList" :key="index">
              <el-card style="margin-top: 10px;text-align: center;">
                <img :src="domain + item" class="image" style="max-height: 100px" />
                <div style="padding: 0px">
                  <div class="bottom clearfix">
                    <el-button-group>
                      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteImg(index)"></el-button>
                    </el-button-group>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
        <div style="height: 10px"></div>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisiblefeel = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分配资源弹框（统一组件）：留学 VIP 页只允许推荐到日语/鸣野 -->
    <AssignResourceDialog :visible.sync="assignDialogVisible" :form="assignForm" :adviser-list="adviserList"
      :market-list="marketList" :user-is-admain="userIsAdmain" :show-student="false" :show-jap="true"
      :show-mingye="true" empty-message="请选择分配给日语或鸣野" @success="getList" />

    <StudentShow :stuid="showstuid" v-on:setzero="showstuid = 0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import SelectAbroad from "@/components/SelectAbroad";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";

export default {
  name: 'vipstu',
  data() {

    return {
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(),
      userIsDocument: user.isDocument(),
      userIsDocumentGroup: user.isDocumentGroup(),
      userIsMarket: user.isMarket(),
      query: {}, //对象
      state: "a",
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      dialogVisiblefeel: false,//申请案例
      imgList: [],//聊天记录
      evalDialogVisible: false,
      eval: {}, //完善地址，下载地址
      submiting: false,
      stuid: 0,
      areaList: [], //地区
      selectedOptions: [],
      adviserList: [],
      documentList: [],
      marketList: [],
      daterange: [], //缴费时间
      inputDate: [],//录入时间
      sourselist: [], //来源
      selectedOrigion: [],
      edubacklist: url.getEduBack(), //学历
      studentTypeList: url.getStudentTypeList(), // 学生/家长
      purposeList: url.getStudentPurposeList(), // 赴日目的（筛选用）
      ageRangeList: url.getAgeRangeList(), // 年龄阶段（筛选用）
      japlist: url.getJapLevelListForStu(), // 日语水平（统一数据）
      enlist: [
        { id: "好", name: "好" },
        { id: "一般", name: "一般" },
        { id: "差", name: "差" },
        { id: "有托福托业成绩", name: "有托福托业成绩" },
      ], //英语水平
      schoollist: [], //获取学校
      abroadTimeDialog2: false,
      showstuid: 0,
      tiktoklist: [
        { id: 1, name: "直播" },
        { id: 2, name: "短视频" },
      ], //抖音推荐
      partlist: [], //合作方推荐
      ischildren: false,
      labelorgin: '',
      agelist: [
        { id: "20以内", name: "20以内" },
        { id: "20-25", name: "20-25" },
        { id: "25-30", name: "25-30" },
        { id: "30-35", name: "30-35" },
        { id: "35-40", name: "35-40" },
        { id: "40以上", name: "40以上" },],//年龄列表
      assignDialogVisible: false,
      assignForm: { resourceTypes: [] },
      assignSubmiting: false,
      followDialogVisible: false,
      followDialogLoading: false,
      followType: '',
      followDialogRow: null,
      followData: { list: [] },
      followJapHasCourse: false,
      followMingyeDetail: null,
      followDialogTitle: '',
    };
  },
  components: {
    StudentShow,
    SelectAbroad,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  methods: {
    canEditStu(row) {
      return user.canEditStu(row);
    },
    isMarketingOnlyStu(row) {
      return user.isMarketingOnlyStu(row);
    },
    isNoAdviserStu(row) {
      return user.isNoAdviserStu(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    areaChange: function (e) {

      this.query.zzCity = e[1] || e[0];
      this.selList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
      });
    },
    // 获取合作方
    getAllPart() {
      var _this = this;
      var link = url.getStu("GetAllPartner");
      $.get(link, {}, (data) => {
        _this.partlist = data;
      });
    },

    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.buildListParams();
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getStu("GetList_OrderByPay");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    buildListParams: function () {
      var params = Object.assign({}, this.query);
      if (this.query.daterange && this.query.daterange.length >= 2) {
        params.payStart = this.query.daterange[0];
        params.payEnd = this.query.daterange[1];
      } else {
        params.payStart = "";
        params.payEnd = "";
      }
      if (this.query.inputDate && this.query.inputDate.length >= 2) {
        params.inputStart = this.query.inputDate[0];
        params.inputEnd = this.query.inputDate[1];
      } else {
        params.inputStart = "";
        params.inputEnd = "";
      }
      if (this.selectedOrigion.length > 0) {
        params.origin = this.selectedOrigion[0];
        params.recName = this.selectedOrigion[1];
      } else {
        params.origin = "";
        params.recName = "";
      }
      params.state = this.state;
      delete params.daterange;
      delete params.inputDate;
      return params;
    },
    changeReouce(val) {
      var origin = this.form.origin;
      this.labelorgin = origin;

      const index = this.sourselist.findIndex(item => item.id === val);
      //  console.log(this.sourselist[index].children);
      if (this.sourselist[index].children == null) {
        this.ischildren = false
        return false;
      }
      var children = this.sourselist[index].children;
      if (children.length >= 1) {
        this.tiktoklist = children;
        this.ischildren = true;

      } else {
        this.ischildren = false
      }
    },
    //按状态查询
    stateClick: function () {



      this.getList();
    },
    //获取学校
    school: function () {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, (data) => {
        _this.schoollist = data;

      });
    },
    //按学校查询
    schoolClick: function () {
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //导出操作（各角色可导出自己可见范围内的学生，数据权限由后端 GetPageOrderByPay 控制）
    exportClick() {
      var params = this.buildListParams();
      var result = [];
      for (var item in params) {
        if (params[item] !== undefined && params[item] !== "" && params[item] !== null) {
          result.push(item + "=" + encodeURIComponent(params[item]));
        }
      }
      result.push('exportName=vip学生列表');
      var link = url.getStu("ExportVip1") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    //获取地区数据
    getArea() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStu("addorupdate_base");
      var info = this.form;
      console.log("info:", info);
      if (this.selectedOptions) {
        info.zzProvinceName = this.selectedOptions[0];
        info.zzCityName = this.selectedOptions[1];
      } else {
        info.zzProvinceName = "";
        info.zzCityName = "";
      }
      info.imgList = JSON.stringify(this.imgList);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.dialogVisiblefeel = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      // this.form.abroadDate='';
      this.form = Object.assign({}, row);
      // this.form.abroadDate = row.abroadDate || '';
      this.dialogVisible = true;
      this.changeReouce(this.form.origin);

      this.selectedOptions = [row.zzProvinceName, row.zzCityName];
      // 将留学时间传递给子组件
      this.$nextTick(() => {
        this.$refs.selectAbroad && this.$refs.selectAbroad.setAbroadTime(this.form.abroadDate);
      });
    },
    // 分配资源（由统一组件 AssignResourceDialog 提交）
    assignClick: function (row) {
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        id: row.id,
        studentID: row.id,
        realName: row.realName,
        isStudent: true,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
    getStateName: function (state) {
      return state ? '跟进中' : '待分配';
    },
    showFollowDialog: function (type, row) {
      this.followType = type;
      this.followDialogRow = row || {};
      this.followDialogVisible = true;
    },
    viewJapFollow: function (studentID) {
      if (studentID) window.open('/vue/japfollow?id=' + studentID, '_blank');
    },
    viewMingyeFollow: function (studentID) {
      if (studentID) window.open('/vue/mingyefollow?id=' + studentID, '_blank');
    },
    //编辑
    editClickFeel: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisiblefeel = true;
      //聊天图片
      this.imgList = [];
      if (this.form.imgList != null) {
        this.imgList = JSON.parse(this.form.imgList);
      }
    },
    //跳转详情
    goTo: function (id) {
      this.$router.push({
        name: "follow",
        query: { id: id },
      });
    },
    //跳转评估表
    tabClick: function (id) {
      var _this = this;
      _this.evalDialogVisible = true;
      var link = url.getStu("getlink");
      $.get(link, { id: id }, (data) => {
        _this.eval = data;
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getStu("delete_base"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    dialogOpended() {
      var _this = this;
      /**截图上传**/
      if ($("#uploadBtn .uploader_text").length <= 0)
        $("#uploadBtn").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          type: "single", //指定处理类型
          max: 1024 * 1024 * 1,
          maxWidth: 2000,
          maxHeight: 2000,
          onSuccess: function (data) {
            //添加到列表,每个图片上传成功都会触发
            console.log(_this.imgList);

            _this.imgList.push(data.relativeName);
          },
        });
      if ($('#uploadBtn1 input').length == 0) {
        $('#uploadBtn1').uploader({
          url: url.getUpload(),
          text: '上传文件',
          fileExts: 'pdf;doc;docx',
          handleType: '0',
          onSuccess: function (data) {
            console.info(data)
            var src = url.getDomain() + data.relativeName
            _this.book = data.relativeName
            _this.form.book = data.relativeName
          }

        })
      }
      if ($("#uploadBtnConfig input").length == 0) {
        $("#uploadBtnConfig").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png;jpeg",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "bookPhoto", data.relativeName);
          },
        });
      }
    },
    deleteImg(index) {
      this.imgList.splice(index, 1);
    },
  },
  created() { },
  mounted() {
    var _this = this;
    //参数处理
    _this.query = _this.$route.query;
    // 来源
    this.getAllOrigin();
    //获取合作方
    _this.getAllPart();
    //获取学生列表
    this.getList();
    //获取地区
    this.getArea();
    //获取学校
    this.school();
    // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
    $.get(url.getStu("getenableusers"), (res) => {
      var list = res || [];
      _this.adviserList = list;
      _this.marketList = list;
    });
    $.get(url.getStu("getdocument"), (res) => {
      _this.documentList = res;
    });
  },
};
</script>

<style scoped>
.follow-detail-block div {
  margin-bottom: 10px;
  line-height: 1.6;
}
</style>
